import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import CompanyInstallation from 'modules/marketplace/store/models/companyInstallations'

export class CompanyInstallations extends Collection<CompanyInstallation> {
  get cacheKey(): string {
    return 'companyInstallations'
  }

  model() {
    return CompanyInstallation
  }
}

const { provider: CompanyInstallationsProvider, hook: useCompanyInstallations } =
  createCollectionContext<CompanyInstallation, CompanyInstallations>()

export { CompanyInstallationsProvider, useCompanyInstallations }
